
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { 
  PhoneCall, 
  MapPin, 
  Clock, 
  TrendingUp, 
  ShieldCheck, 
  Store, 
  Truck 
} from 'lucide-react';

const AboutSection = () => {
  // Fixed video URL provided by user
  const videoUrl = "https://dhpifehbegozqmcrwlsw.supabase.co/storage/v1/object/public/media-files/Kooperasie%20Veevoer%20Winkel%2050Mb.mp4";

  return (
    <section className="py-16 bg-cream-100">
      <div className="container-custom">

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Left Column - About Us */}
          <div>
            <h2 className="section-title">About Koöperasie Veevoer Winkel</h2>
            <p className="text-lg mb-6 text-gray-700">
              Since 2016, we've been serving the agricultural community with quality products and expert advice. Our mission is to support farmers with reliable supplies at competitive prices.
            </p>
            <p className="mb-6 text-gray-700">
              Founded by farmers for farmers, we understand the challenges and requirements of modern agriculture in South Africa. Our team brings decades of combined experience to help you make informed decisions about your farming needs.
            </p>
            <div className="space-y-4 mb-6">
              <div className="flex items-start">
                <div className="mt-1 mr-3 bg-springbok-100 p-2 rounded-full text-springbok-500">
                  <PhoneCall size={20} />
                </div>
                <div>
                  <h4 className="font-semibold">Contact Us</h4>
                  <p className="text-gray-600">061 321 5050</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="mt-1 mr-3 bg-springbok-100 p-2 rounded-full text-springbok-500">
                  <MapPin size={20} />
                </div>
                <div>
                  <h4 className="font-semibold">Visit Our Store</h4>
                  <p className="text-gray-600">
                    Plot 365, cnr R104 (Old Bronkhortspruit Road) and R964 (Donkerhoek road), Donkerhoek, Pretoria East, 0185
                  </p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="mt-1 mr-3 bg-springbok-100 p-2 rounded-full text-springbok-500">
                  <Clock size={20} />
                </div>
                <div>
                  <h4 className="font-semibold">Opening Hours</h4>
                  <p className="text-gray-600">Mon-Fri: 8:00 AM - 5:00 PM</p>
                  <p className="text-gray-600">Sat: 8:00 AM - 1:00 PM</p>
                  <p className="text-gray-600">Sun: Closed</p>
                  <p className="text-gray-600">Public Holidays: 8:00 AM - 1:00 PM</p>
                  <p className="text-gray-600 text-sm">(Closed on Christian Holidays)</p>
                  <p className="text-gray-600 text-sm font-medium mt-2">
                    *No deliveries over weekends and on Public Holidays
                  </p>
                </div>
              </div>
            </div>
            <Link to="/about">
              <Button data-gradient="green">
                More About Us and Videos
              </Button>
            </Link>
          </div>
          
          {/* Right Column - Why Choose Us */}
          <div className="bg-white p-8 rounded-lg shadow-md">
            <h3 className="text-2xl font-semibold mb-6 text-springbok-800">Why Choose Us</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="group">
                <div className="mb-3 bg-springbok-50 p-3 rounded-lg inline-block group-hover:bg-springbok-100 transition-colors">
                  <Store className="text-springbok-500 icon-animated" size={24} />
                </div>
                <h4 className="font-semibold text-lg mb-1">Large Selection</h4>
                <p className="text-gray-600">Comprehensive range of agricultural and pet supplies under one roof.</p>
              </div>
              
              <div className="group">
                <div className="mb-3 bg-springbok-50 p-3 rounded-lg inline-block group-hover:bg-springbok-100 transition-colors">
                  <ShieldCheck className="text-springbok-500 icon-animated" size={24} />
                </div>
                <h4 className="font-semibold text-lg mb-1">Quality Guaranteed</h4>
                <p className="text-gray-600">We source only from trusted, reputable manufacturers and suppliers.</p>
              </div>
              
              <div className="group">
                <div className="mb-3 bg-springbok-50 p-3 rounded-lg inline-block group-hover:bg-springbok-100 transition-colors">
                  <TrendingUp className="text-springbok-500 icon-animated" size={24} />
                </div>
                <h4 className="font-semibold text-lg mb-1">Expert Advice</h4>
                <p className="text-gray-600">Our knowledgeable team provides guidance on all your farming needs.</p>
              </div>
              
              <div className="group">
                <div className="mb-3 bg-springbok-50 p-3 rounded-lg inline-block group-hover:bg-springbok-100 transition-colors">
                  <Truck className="text-springbok-500 icon-animated" size={24} />
                </div>
                <h4 className="font-semibold text-lg mb-1">Fast Delivery</h4>
                <p className="text-gray-600">Prompt, reliable delivery service to your farm or home.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
